import React from 'react';
import PropTypes from 'prop-types';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMConst from 'lib/SMConst';

class SMReservationNoticeView extends React.Component {
  
  isStatusShowTel () {
    let reservation = this.props.reservation;
    return (
      reservation.status == SMConst.ReservationStatus.Paid ||
      reservation.status == SMConst.ReservationStatus.Postpay ||
      reservation.status == SMConst.ReservationStatus.Refunded
    );
  }
  
  trackPageEvent (e) {
      SMTrackHelper.pageEvent('od change inquiry_to_reservation_0');
  }  
  
  isOwnerAlwaysShowTel () {
    let reservation = this.props.reservation;
    return (
      reservation.owner && reservation.owner.user_tel_display_type == SMConst.UserTelDisplayType.Always
    );
  }

  canShowTel (reservation) {
    return (
      this.isStatusShowTel() || this.isOwnerAlwaysShowTel()
    );
  }

  getShowTelMsg () {
    let msg = "";
    if (this.isStatusShowTel()) {
      msg = "予約が確定されました。今後はお電話でも連絡が可能です。電話番号：";
    } else if (this.isOwnerAlwaysShowTel()) {
      msg = "お電話でも連絡が可能です。電話番号：";
    }
    return msg;
  }

  renderTel (model,msg) {
    return (
      <p key="tel">{msg}<a href={"tel:" + model.tel}>{model.tel}</a></p>
    );
  }

  renderOwner () {
    let reservation = this.props.reservation,
        user = reservation.user,
        owner = reservation.owner,
        rows = [];
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      rows.push(<p key="undone">まだ予約は完了していません。予約を完了するには <a onClick={this.trackPageEvent.bind(this)} href={Routes.edit_owner_dashboard_reservation_path(owner.username, reservation.uid)}>予約リクエストに変更</a> してください。</p>);
    } else {
      if (this.canShowTel()) {
        rows.push(this.renderTel(user.contact,this.getShowTelMsg()));
      }
    }
    return rows;
  }
  
  renderUser () {
    let reservation = this.props.reservation,
        user = reservation.user,
        owner = reservation.owner,
        rows = [];
    if (reservation.method == SMConst.ReservationMethod.Inquiry ||
      (reservation.method == SMConst.ReservationMethod.Concierge && reservation.concierge.via == SMConst.ConciergeVia.Inquiry)) {
      rows.push(<p key="undone">まだ予約は完了していません。予約を完了するには <a href={Routes.space_room_reservations_path(reservation.room.space.username, reservation.room.uid, {inquiry_id: reservation.uid})}>予約リクエストに変更</a> してください。</p>);
    } else {
      if (this.canShowTel()) {
        rows.push(this.renderTel(owner,this.getShowTelMsg()));
      }
    }
    return rows;
  }
  
  render () {
    let rows = (this.props.isOwner) ? this.renderOwner() : this.renderUser();
    if (rows.length > 0) {
      return (<div className="dashboard-message__info mt40">{rows}</div>);
    }
    return <div />;
  }
}
SMReservationNoticeView.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  reservation: PropTypes.object.isRequired,
};
export default SMReservationNoticeView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationNoticeView.jsx